import moment from "moment-timezone";
import "../../input/validation.js";
import "../../input/DatePicker.js";
import "../../input/DateRangePicker.js";
import "../../input/StyledInput.js";
import "../../input/FormInput.js";
import "../../input/StyledFormInputHoc.js";
import "react";
import { momentToTimestampSeconds, isCurrentDate, endDateNow } from "../../../utils/date.js";
import "react-intl";
import "../../input/DateSinglePicker.localize.js";
import { convertSecondsToInternalFormat, convertInternalFormatToSeconds } from "../../input/utils.js";
import "../../input/hooks.js";
import "@mui/material";
function useDateRangeFilter({ value, onChange }, availableRangeForSelection, onSelect) {
  const dateRangeVal = {
    from: convertSecondsToInternalFormat(value?.from),
    to: convertSecondsToInternalFormat(value?.to)
  };
  const availableRangeForSelectionLocal = availableRangeForSelection ? {
    from: availableRangeForSelection?.from ? convertSecondsToInternalFormat(momentToTimestampSeconds(moment(availableRangeForSelection?.from))) : null,
    to: availableRangeForSelection?.to ? convertSecondsToInternalFormat(momentToTimestampSeconds(moment(availableRangeForSelection?.to))) : null
  } : null;
  function handleChange(newValue) {
    const result = {
      from: convertInternalFormatToSeconds(newValue?.from, "start"),
      to: newValue?.to && isCurrentDate(newValue.to) ? endDateNow : convertInternalFormatToSeconds(newValue?.to, "end")
    };
    onChange(result);
  }
  function handleSelect(newValue) {
    if (onSelect) {
      const result = {
        from: convertInternalFormatToSeconds(newValue?.from, "start"),
        to: newValue?.to && isCurrentDate(newValue.to) ? endDateNow : convertInternalFormatToSeconds(newValue?.to, "end")
      };
      onSelect(result);
    }
  }
  return { value: dateRangeVal, handleChange, handleSelect, availableRangeForSelection: availableRangeForSelectionLocal };
}
export {
  useDateRangeFilter
};
//# sourceMappingURL=hooks.js.map
